import { Outlet } from 'react-router'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect } from 'react'
import SideMenu from 'core/widgets/side-menu/SideMenu'
import DeactivatedAccountBanner from 'core/widgets/DeactivatedAccountBanner'
import {
  MemberInviteUrl,
  PayPeriodDetailUrl,
  ReportDetailUrl,
  ScheduleDetailUrl,
  TeamComplianceDetailUrl,
  TeamMergeConfigImportMembersUrl,
  TeamMergeConfigTeamHierarchyUrl,
  TeamMergeConfigUrl,
  TeamMergeConfigUserFieldsUrl,
  TeamReportDetailUrl
} from 'constants/RouteUrls'
import useNavigation from 'core/hooks/navigation/useNavigation'
import { matchPath } from 'react-router'
import useAuth from 'core/hooks/auth/useAuth'

const SideMenuLayout = () => {
  const { pathname } = useNavigation()
  const { isAuthenticated } = useAuth()
  const excludedUrlsFromLayout = [
    '/auth/*',
    '/password_resets',
    ReportDetailUrl,
    TeamReportDetailUrl,
    MemberInviteUrl,
    TeamComplianceDetailUrl,
    ScheduleDetailUrl,
    PayPeriodDetailUrl,
    TeamMergeConfigUrl,
    TeamMergeConfigImportMembersUrl,
    TeamMergeConfigUserFieldsUrl,
    TeamMergeConfigTeamHierarchyUrl
  ]

  const shouldExcludeRoute = !!excludedUrlsFromLayout.find((path) => {
    return !!matchPath(path, pathname)
  })

  useEffect(() => {
    const body = document.getElementsByTagName('body')?.[0]
    const root = document.getElementById('root')
    body?.classList?.add('overflow-hidden')
    root?.classList?.add('overflow-hidden')
    return () => {
      body?.classList?.remove('overflow-hidden')
      root?.classList?.remove('overflow-hidden')
    }
  }, [])

  if (!isAuthenticated) return null
  return shouldExcludeRoute ? (
    <Outlet />
  ) : (
    <>
      <AnimatePresence mode="sync">
        <section className="flex flex-row h-screen relative">
          <SideMenu />
          <motion.div className="w-full overflow-auto pb-28">
            <DeactivatedAccountBanner />
            <div className="p-7">
              <Outlet />
            </div>
          </motion.div>
        </section>
      </AnimatePresence>
    </>
  )
}

export default SideMenuLayout
